<template lang="pug">
  BasePopup.b-user-detail-popup(v-if="isOpened" @close="isOpened = false;")
    ._container
      UserAvatar._avatar(:user="avatar" :size="80")
      ._name {{ user.name }} {{ user.surname }}
      template(v-for="row in table")
        template(v-if="row.value")
          ._label {{ row.name }}
          a._value(v-if="row.href" :href="row.href(row.value)") {{ row.value }}
          ._value(v-else) {{ row.value }}
          Icon._copy(name="copy" pointer @click.native="copy(row.value)" colored style="color: #788CA1")
      ._footer(v-if="$slots.default")
        slot
</template>

<script>
import utils from '@/utils/common';

import UserAvatar from '@/components/UserAvatar.vue';
import BasePopup from '@/components/BasePopup.vue';

export default {
  name: 'UserDetailPopup',
  components: { BasePopup, UserAvatar },
  controller: null,
  data() {
    return {
      isOpened: false,
      user: {}
    };
  },
  computed: {
    createdAt() { return utils.convertDateToString(this.user.createdAt); },
    dateBirth() { return utils.convertDateToString(this.user.dateBirth); },
    image() { return this.user?.avatar?.thumbnails?.preview; },
    avatar() { return this.image ? { id: this.user.id, avatar: { url: this.image } } : { id: this.user.id }; },
    table() {
      return [
        { name: 'Дата регистрации',     value: this.createdAt,      href: null,                             },
        { name: 'Дата рождения',        value: this.dateBirth,       href: null,                             },
        { name: 'E-mail',               value: this.user.email,     href: (val) => `mailto:${val}`,         },
        { name: 'Телефон',              value: this.user.phone,     href: (val) => `tel:${val}`,            },
        { name: 'telegram',             value: this.user.telegram,  href: (val) => `https://t.me/${val}`,   },
        { name: 'whatsapp',             value: this.user.whatsapp,  href: (val) => `https://wa.me/${val}`,  },
      ];
    }
  },
  methods: {
    open(userData) {
      this.user = userData;
      this.isOpened = true;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close() {
      this.isOpened = false;
      this.user = null;
      this.$options.controller.resolve();
    },
    copy(value) {
      navigator.clipboard.writeText(value);
      this.$push({ text: 'Скопировано в буфер обмена' });
    }
  },
};
</script>

<style scoped lang="scss">
.user-detail-popup {


  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr 20px;
    gap: 10px;
    min-width: 370px;
  }

  &__avatar {
    justify-self: center;
    grid-column: 3 span;
  }

  &__name {
    justify-self: center;
    grid-column: 3 span;

    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #1E3147;
    margin-bottom: 10px;
  }

  &__social-icon {
    fill: #99A3C5;
  }

  &__label {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;

    color: #1E3147;
  }

  &__value {
    justify-self: right;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #33A1FB;
  }

  &__copy {
    justify-self: right;
    align-self: center;
    width: 15px;
    height: 15px;
  }

  &__footer {
    margin-top: 25px;
    grid-column: 3 span;
  }
}
</style>
